import { SegmentedControl } from '../../components/SegmentedControl';
import type { SegmentedControlSize } from '../../components/SegmentedControl/SegmentedControl.types';
import { Grid2x2, List } from '../../icons/lucide';

export type ViewModeToggleValue = 'grid' | 'list';

export interface ViewModeToggleProps {
  value: ViewModeToggleValue;
  onChange: (value: ViewModeToggleValue) => void;
  /** Pre-translated accessibility labels for the two segments. */
  gridLabel?: string;
  listLabel?: string;
  size?: SegmentedControlSize;
  testID?: string;
}

/**
 * The grid ⇄ list switch — one definition for every surface that offers it
 * (the deck filter panel, web's quizzes panel, web's dashboard headers). The
 * CHOICE it edits is app-wide (`@flashka/shared/dashboard/view-mode`); this is
 * only the control.
 */
export function ViewModeToggle({
  value,
  onChange,
  gridLabel,
  listLabel,
  size = 'm',
  testID,
}: ViewModeToggleProps) {
  return (
    <SegmentedControl<ViewModeToggleValue>
      size={size}
      value={value}
      onValueChange={onChange}
      testID={testID}
      items={[
        { value: 'grid', icon: Grid2x2, accessibilityLabel: gridLabel },
        { value: 'list', icon: List, accessibilityLabel: listLabel },
      ]}
    />
  );
}
